import * as React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import './AdminMenu.scss';
import {
  useCurrentUser,
  usePermissions
} from 'client/components/auth/AuthModule';
import { UserOutlined } from '@ant-design/icons';
import { LogoutButton } from 'client/components/auth/logout/LogoutButton';
import { useCurrentMenuKey } from 'client/core/router/breadcrumb/BreadcrumbContext';
const { SubMenu } = Menu;

export interface AdminMenuProps {}

/**
 * Menu principale dall'area amministrazione dell'applicazione
 */
export function AdminMenu(props: AdminMenuProps) {
  const currentPathKey = useCurrentMenuKey();

  const currentUser = useCurrentUser();
  const permissions = usePermissions();

  if (!currentUser) return null;

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      className="admin-menu"
      selectedKeys={currentPathKey}
      style={{ lineHeight: '36px' }}
    >
      {permissions.has('procedure.read:list') && (
        <Menu.Item key="admin/procedures">
          <Link to="/admin">Tutte le Domande</Link>
        </Menu.Item>
      )}

      {permissions.has('users.read') && (
        <Menu.Item key="admin/users">
          <Link to="/admin/users">Utenti</Link>
        </Menu.Item>
      )}

      {permissions.has('users.read') && (
        <Menu.Item key="admin/testers">
          <Link to="/admin/testers">Collaudatori</Link>
        </Menu.Item>
      )}

      {permissions.has('users-grants.read') && (
        <Menu.Item key="admin/user-grants">
          <Link to="/admin/user-grants">Abilitazioni</Link>
        </Menu.Item>
      )}

      <Menu.Item key="front">
        <Link to="/">Frontend</Link>
      </Menu.Item>

      <SubMenu
        rootPrefixCls="admin-menu-submenu"
        popupOffset={[0, 1]}
        key="user"
        icon={<UserOutlined />}
        title={currentUser?.name}
        style={{ float: 'right' }}
      >
        <Menu.Item>
          <LogoutButton />
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
}
